import type {
  ContentBuyTicketPageQueryVariables,
  ContentCheckFreeTicketQueryVariables,
  ContentMyTicketQueryVariables,
  ContentTicketHistoryBuyDetailQueryVariables,
  ContentTicketHistoryBuyQueryVariables,
  ReadyToUseTicketQueryVariables,
  SetReadyToUseTicketQueryVariables,
} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Ticket 도메인 Query Key 관리
 */
export const TICKET_QUERY_KEY_MAP = {
  /**
   * 이용권 구매 페이지 정보 조회
   * Origin: useContentBuyTicketPageQuery.getKey
   */
  contentBuyTicketPage: (variables: ContentBuyTicketPageQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentBuyTicketPage', variables] as const,
  /**
   * 무료 이용권 확인
   * Origin: useContentCheckFreeTicketQuery.getKey
   */
  contentCheckFreeTicket: (variables: ContentCheckFreeTicketQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentCheckFreeTicket', variables] as const,
  /**
   * 보유 이용권 조회
   * Origin: useContentMyTicketQuery.getKey
   */
  contentMyTicket: (variables: ContentMyTicketQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'contentMyTicket', variables] as const,
  /**
   * 이용권 구매 내역 조회 (Infinite)
   * Origin: useInfiniteContentTicketHistoryBuyQuery.getKey
   */
  infiniteContentTicketHistoryBuy: (
    variables: ContentTicketHistoryBuyQueryVariables
  ) =>
    [
      ADAPTER_QUERY_KEY_PREFIX,
      'contentTicketHistoryBuy.infinite',
      variables,
    ] as const,
  /**
   * 이용권 구매 내역 상세 조회
   * Origin: useContentTicketHistoryBuyDetailQuery.getKey
   */
  contentTicketHistoryBuyDetail: (
    variables: ContentTicketHistoryBuyDetailQueryVariables
  ) =>
    [
      ADAPTER_QUERY_KEY_PREFIX,
      'contentTicketHistoryBuyDetail',
      variables,
    ] as const,
  /**
   * 이용권 준비 상태 조회
   * Origin: useReadyToUseTicketQuery.getKey
   */
  readyToUseTicket: (variables: ReadyToUseTicketQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'readyToUseTicket', variables] as const,
  /**
   * 세트 이용권 준비 상태 조회
   * Origin: useSetReadyToUseTicketQuery.getKey
   */
  setReadyToUseTicket: (variables: SetReadyToUseTicketQueryVariables) =>
    [ADAPTER_QUERY_KEY_PREFIX, 'setReadyToUseTicket', variables] as const,
} as const;

/**
 * Ticket 도메인 Mutation Key 관리
 */
export const TICKET_MUTATION_KEY_MAP = {
  /**
   * 이용권 구매
   * Origin: useBuyTicketMutation (getKey 없음)
   */
  buyTicket: 'buyTicket',
  /**
   * 무료 이용권 수령
   * Origin: useReceiveTicketFreeMutation (getKey 없음)
   */
  receiveTicketFree: 'receiveTicketFree',
} as const;

/**
 * 배너 필터링에 사용되는 허용된 스킴 리스트
 * Origin: contentBuyTicketPage.resolver.ts
 */
export const ALLOW_LEGACY_SCHEME_LIST = [
  'kakaopage://exec?goto_auto_charge',
  'kakaopage://exec?open_web_with_auth/relay/tvpoint',
  'kakaopage://exec?open_web_with_auth/store/event',
] as const;

export const ALLOW_SCHEME_LIST = [
  'kakaopage://open/webview/autocharge',
  'kakaopage://open/webview/tvpoint',
  'kakaopage://open/webview/event',
] as const;
